import { css } from '@emotion/core';

export default (
  classes,
  variables,
  cybs,
  hasButton
) => ({
  wrapperDiv: css`
    @media (max-width: 320px) {
      width: 100%;
    }
  `,
  leftTitle: css`
    ${classes && classes.structure
      ? classes.structure.margin.space.right[1]
      : 'margin-right: 0.5rem;'}
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
    word-break: break-word;
  `,
  subtitle: css`
    ${classes && classes.structure
      ? classes.structure.margin.space.right[1]
      : 'margin-right: 0.5rem;'}
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
    word-break: break-word;
  `,
  additionalSubtitle: css`
    ${!hasButton && `box-shadow: inset 1px 0 #222;` }
    ${classes && classes.structure
      ? classes.structure.margin.space.right[1]
      : 'margin-right: 0.5rem;'}
    ${classes && classes.structure
      ? classes.structure.padding.space.left[1]
      : 'padding-left: 0.5rem;'}
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
    word-break: break-word;
  `
})